import { environment } from "src/environments/environment";

export function powerHelper() {
    return () => environment.production ? console.log("%c14837", "font-family: Roboto; text-transform: uppercase; font-size: 30px; font-weight: bold") : null;
}